// fallback product images utility
import ImageIcon from '../../assets/fallback-product-images/image-icon.svg';
import DishwasherIcon from '../../assets/fallback-product-images/icon-dishwasher.svg';
import DryerIcon from '../../assets/fallback-product-images/icon-dryer.svg';
import FireplaceIcon from '../../assets/fallback-product-images/icon-fireplace.svg';
import FurnaceIcon from '../../assets/fallback-product-images/icon-furnace.svg';
import GarageOpenerIcon from '../../assets/fallback-product-images/icon-garage-opener.svg';
import HoodIcon from '../../assets/fallback-product-images/icon-hood.svg';
import OvenIcon from '../../assets/fallback-product-images/icon-oven.svg';
import RangeIcon from '../../assets/fallback-product-images/icon-range.svg';
import RefrigeratorIcon from '../../assets/fallback-product-images/icon-refrigerator.svg';
import WasherIcon from '../../assets/fallback-product-images/icon-washer.svg';
import WaterSoftenerIcon from '../../assets/fallback-product-images/icon-water-softner.svg';

export const fallbackProductImages = {
  dishwasher: DishwasherIcon,
  dryer: DryerIcon,
  fireplace: FireplaceIcon,
  furnace: FurnaceIcon,
  garage_opener: GarageOpenerIcon,
  hood: HoodIcon,
  oven: OvenIcon,
  range: RangeIcon,
  refrigerator: RefrigeratorIcon,
  washer: WasherIcon,
  water_softener: WaterSoftenerIcon
};

/**
 * returns the appropriate fallback image source for a product type
 * @param type - product type string
 * @returns image source URL or default ImageIcon
 */
export const getFallbackProductImage = (type: string): string => {
  return fallbackProductImages[type as keyof typeof fallbackProductImages] || ImageIcon;
};
